import {getStartOfWeek} from '@igp/shared/utils';

const availableWeekCount = 14; // ~ 3 months
export const firstAvailableDate = getStartOfWeek(availableWeekCount);
